import React, { useContext, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Tag, Divider } from 'antd'
import moment from 'moment'
import useAction from 'utils/useAction'
import Modal from 'components/Modal/Modal'
import {
  selectors as surpriseBoxSelectors,
  actions as surpriseBoxActions,
} from 'domains/surpriseBox'
import {
  STATUS_COLORS,
  STATUS_LABELS,
  SURPRISE_BOX_DATE_TIME_FORMAT,
} from '../constants'
import { DetailsGrid } from '../SurpriseBox.styles'

const formatDateTime = (value) =>
  value ? moment.utc(value).local().format(SURPRISE_BOX_DATE_TIME_FORMAT) : '-'

const formatMoney = (value) =>
  value === null || value === undefined ? '-' : `$${Number(value).toFixed(2)}`

const PromotionDetails = () => {
  const modal = useContext(Modal.Context)
  const promotion = useSelector(surpriseBoxSelectors.getCurrentPromotion)
  const fetchPromotion = useAction(surpriseBoxActions.fetchPromotion)
  const setCurrentPromotion = useAction(surpriseBoxActions.setCurrentPromotion)

  const id = modal.data?.id

  useEffect(() => {
    if (id) fetchPromotion({ id })
    return () => setCurrentPromotion(null)
  }, [id]) // eslint-disable-line react-hooks/exhaustive-deps

  if (!promotion) return <div>Loading…</div>

  const summary = promotion.summary || {}

  return (
    <>
      <DetailsGrid as="dl">
        <dt>ID</dt><dd>{promotion.id}</dd>
        <dt>Name</dt><dd>{promotion.name}</dd>
        <dt>Status</dt>
        <dd>
          <Tag color={STATUS_COLORS[promotion.status] || 'default'}>
            {STATUS_LABELS[promotion.status] || promotion.status}
          </Tag>
        </dd>
        <dt>Ticket Price</dt><dd>{formatMoney(promotion.ticket_price)}</dd>
        <dt>Prize Value</dt><dd>{formatMoney(promotion.prize_value)}</dd>
        <dt>Promotion Start</dt><dd>{formatDateTime(promotion.promotion_start_time)}</dd>
        <dt>Sales Close</dt><dd>{formatDateTime(promotion.sales_close_time)}</dd>
        <dt>Prize Draw Time</dt><dd>{formatDateTime(promotion.draw_time)}</dd>
        <dt>Prize Drawn At</dt><dd>{formatDateTime(promotion.drawn_at)}</dd>
        <dt>Winner Ticket ID</dt><dd>{promotion.winner_ticket_id || '-'}</dd>
        <dt>Created At</dt><dd>{formatDateTime(promotion.created_at)}</dd>
        <dt>Updated At</dt><dd>{formatDateTime(promotion.updated_at)}</dd>
      </DetailsGrid>

      <Divider orientation="left">Summary</Divider>
      <DetailsGrid as="dl">
        <dt>Tickets Sold</dt><dd>{summary.tickets_sold ?? 0}</dd>
        <dt>Unique Buyers</dt><dd>{summary.unique_buyers ?? 0}</dd>
        <dt>Winner Email</dt><dd>{summary.winner_email || '-'}</dd>
        <dt>Winner Country</dt><dd>{summary.winner_country_code || '-'}</dd>
      </DetailsGrid>
    </>
  )
}

export default PromotionDetails
